import { useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';

import useNoundlesTheory from './useNoundlesTheory';

const useEvilNoundleBalance = () => {
  const { account } = useWeb3React();
  const noundlesTheory = useNoundlesTheory();

  const [evilNoundleBalance, setEvilNoundleBalance] = useState(0);

  useEffect(() => {
    let ignore = false;
    setEvilNoundleBalance(0);
    if (noundlesTheory) {
      const fetchNoundles = () => {
        noundlesTheory.evilBalance(account).then((evilBalance) => {
          if (!ignore) setEvilNoundleBalance(evilBalance.toNumber());
        });
      };
      fetchNoundles();
      const transferFrom = noundlesTheory.filters.Transfer(account);
      const transferTo = noundlesTheory.filters.Transfer(null, account);
      noundlesTheory.on(transferFrom, fetchNoundles);
      noundlesTheory.on(transferTo, fetchNoundles);
      return () => {
        noundlesTheory.off(transferFrom, fetchNoundles);
        noundlesTheory.off(transferTo, fetchNoundles);
        ignore = true;
      };
    }
  }, [noundlesTheory, account]);

  return evilNoundleBalance;
};

export default useEvilNoundleBalance;
